import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';

export const useEventSessions = (eventId: number) => {
    return useRootSelector(state => state.eventUnions.sessions[eventId] || []);
};
